import { palette } from 'app_previous/styles/colors';
import styled, { css } from 'styled-components';

export const SliderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const SliderContent = styled.div`
  display: flex;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  width: 100%;
  align-items: center;
  max-width: 100vw;
`;

export const SliderListContainer = styled.div`
  width: 100%;
  overflow: hidden;
`;

interface SliderListProps {
  isDragging?: boolean;
  speed?: number;
}

export const SliderList = styled.div<SliderListProps>`
  display: grid;
  box-sizing: border-box;
  margin: 0 auto;

  ${({ isDragging, speed }) =>
    isDragging
      ? ''
      : css`
          > * {
            transition: transform ${speed ?? 200}ms ease-in-out;
          }
        `}
`;

interface SliderItem {
  slideSize?: number;
  clickable?: boolean;
}

export const SliderItem = styled.div<SliderItem>`
  display: block;
  grid-row: 1 / 2;
  grid-column: 1 / 2;
  height: fit-content;

  ${({ slideSize }) =>
    slideSize !== undefined &&
    css`
      width: ${slideSize}px;
    `}

  > div > * {
    width: 100%;
    display: inline-block;
  }
`;

export const ArrowContainer = styled.div`
  cursor: pointer;
  position: relative;
  z-index: 6;
`;

export const DotsContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 0;
  margin-top: 5px;
`;

export const SliderDot = styled.div<{ isActive?: boolean }>`
  width: 20px;
  height: 20px;
  position: relative;
  display: inline-block;
  padding: 0;
  cursor: pointer;
  color: transparent;
  border: 0;
  outline: none;
  background: transparent;

  &:after {
    content: '';
    position: absolute;
    width: 10px;
    height: 10px;
    left: calc(50% - 5px);
    top: calc(50% - 5px);
    border-radius: 50%;
    outline: none;
    background-color: ${palette.text};

    ${({ isActive }) =>
      isActive
        ? css`
            opacity: 0.9;
          `
        : css`
            opacity: 0.25;
          `}
  }
`;
